import request from '@/api/config/request'

const prex = "api/admin/pessoas/empresas/";

export function getDadosEmpresa(eco_codigo) {
    return request({
        url: `${prex}dados/${eco_codigo}`,
        method: 'get'
    })
}

export function putDadosEmpresa(eco_codigo, data) {
    return request({
        url: `${prex}dados/${eco_codigo}`,
        method: 'put',
        data
    })
}

export function getDadosFiscais(eco_codigo) {
    return request({
        url: `${prex}fiscal/${eco_codigo}`,
        method: 'get'
    })
}

export function putDadosFiscais(eco_codigo, data) {
    return request({
        url: `${prex}fiscal/${eco_codigo}`,
        method: 'put',
        data
    })
}

export function getDadosContatos(eco_codigo) {
    return request({
        url: `${prex}contato/${eco_codigo}`,
        method: 'get'
    })
}

export function putDadosContatos(data) {
    return request({
        url: `${prex}contato`,
        method: 'put',
        data
    })
}

export function getDadosUsuarios(eco_codigo) {
    return request({
        url: `${prex}usuarios/${eco_codigo}`,
        method: 'get'
    })
}

export function saveUsuarioEmpresa(eco_codigo, data) {
    return request({
        url: `${prex}usuarios/${eco_codigo}`,
        method: 'put',
        data
    })
}

export function delUsuarioEmpresa(eco_codigo, aut_hash) {
    return request({
        url: `${prex}usuarios/${eco_codigo}/${aut_hash}`,
        method: 'delete'
    })
}
